import React, { useEffect, useState } from "react";
import {
  getBrokerPendingRequests,
  rejectDemoRequest,
  acceptDemoRequest,
} from "../../../Services/BrokersApi";
import {
  Container,
  Typography,
  CircularProgress,
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  TextField,
  Tabs,
  Tab,
  Card,
  Avatar,
  Chip,
  InputAdornment,
  Stack,
} from "@mui/material";
import {
  Info as InfoIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  FilterList as FilterListIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  PendingActions as PendingActionsIcon,
  Close as CloseIcon,
  CalendarToday as CalendarTodayIcon,
  AttachMoney as AttachMoneyIcon,
  Notes as NotesIcon,
  Category as CategoryIcon,
  Stars as StarsIcon,
} from "@mui/icons-material";
import { themeColors } from "../../../theme/colors";
import AllRejectedDemoTap from "./AllRejectedDemoTap";

const NewRequestsPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [requests, setRequests] = useState([]);
  // تتبع معرفات الطلبات الجاري رفضها
  const [rejectingIds, setRejectingIds] = useState([]);

  // حالات حوار قبول الديمو
  const [acceptDialogOpen, setAcceptDialogOpen] = useState(false);
  const [acceptRequestId, setAcceptRequestId] = useState(null);
  const [startDemo, setStartDemo] = useState("");
  const [endDemo, setEndDemo] = useState("");
  const [demoCost, setDemoCost] = useState("");
  const [demoNotes, setDemoNotes] = useState("");
  const [acceptLoadingId, setAcceptLoadingId] = useState(null);
  const [acceptError, setAcceptError] = useState(null);

  // pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // إضافة state للتحكم بالتاب المختار
  const [tabIndex, setTabIndex] = useState(0);

  // حالات حوار عرض الميزات
  const [featuresDialogOpen, setFeaturesDialogOpen] = useState(false);
  const [dialogFeatures, setDialogFeatures] = useState([]);

  // new: search state
  const [searchQuery, setSearchQuery] = useState("");

  // new: created_at date range filters (YYYY-MM-DD)
  const [createdFrom, setCreatedFrom] = useState("");
  const [createdTo, setCreatedTo] = useState("");

  // دالة جلب قابلة لإعادة الاستخدام
  const fetchRequests = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("authToken");
      const data = await getBrokerPendingRequests(null, token);
      setRequests(data || []);
      console.log("Pending requests:", data);
    } catch (err) {
      const msg =
        (err && (err.message || err.msg || JSON.stringify(err))) || "حدث خطأ";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  // reset page when search or created filters change
  useEffect(() => {
    setPage(0);
  }, [searchQuery, createdFrom, createdTo]);

  // دالة لرفض طلب الديمو
  const handleRejectDemo = async (requestId) => {
    if (!requestId) return;
    const token = localStorage.getItem("authToken");
    setRejectingIds((s) => [...s, requestId]);
    try {
      await rejectDemoRequest(requestId, token);
      await fetchRequests();
    } catch (err) {
      setError(
        (err && (err.message || err.msg || JSON.stringify(err))) ||
          "فشل عملية الرفض"
      );
    } finally {
      setRejectingIds((s) => s.filter((id) => id !== requestId));
    }
  };

  // فتح حوار قبول الديمو
  const openAcceptDialog = (req) => {
    setAcceptRequestId(req?.id ?? null);
    // حاول تعبئة القيم الافتراضية لو متوفرة
    setStartDemo(req?.start_demo?.split?.("T")?.[0] ?? "");
    setEndDemo(req?.end_demo?.split?.("T")?.[0] ?? "");
    setDemoCost(req?.cost ?? "");
    setDemoNotes(req?.notes ?? "");
    setAcceptError(null);
    setAcceptDialogOpen(true);
  };
  // غلق حوار قبول الديمو
  const closeAcceptDialog = () => {
    setAcceptDialogOpen(false);
    setAcceptRequestId(null);
    setStartDemo("");
    setEndDemo("");
    setDemoCost("");
    setDemoNotes("");
    setAcceptError(null);
  };

  // إرسال بيانات قبول الديمو
  const handleAcceptSubmit = async () => {
    if (!acceptRequestId) {
      setAcceptError("طلب غير محدد");
      return;
    }
    setAcceptLoadingId(acceptRequestId);
    setAcceptError(null);
    try {
      const token = localStorage.getItem("authToken");
      const payload = {
        start_demo: startDemo || undefined,
        end_demo: endDemo || undefined,
        cost: demoCost || undefined,
        notes: demoNotes || undefined,
      };
      await acceptDemoRequest(acceptRequestId, payload, token);
      await fetchRequests();
      closeAcceptDialog();
    } catch (err) {
      setAcceptError(
        (err && (err.message || err.msg || JSON.stringify(err))) ||
          "فشل قبول الديمو"
      );
    } finally {
      setAcceptLoadingId(null);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // filtering by searchQuery across relevant fields
  const q = (searchQuery || "").trim().toLowerCase();
  const matches = (val) =>
    val != null && String(val).toLowerCase().includes(q);

  const hasCreatedFilter = !!createdFrom || !!createdTo;
  const filteredRequests = requests.filter((req) => {
    const user = req.user || {};
    const plane = req.plane || {};

    // 1) matchesQuery: إذا وُجد نص بحث طبق المطابقة، وإلا اعتبرها مطابقة
    let matchesQuery = true;
    if (q && q.length > 0) {
      matchesQuery =
        matches(user.name) ||
        matches(user.email) ||
        matches(user.phone) ||
        matches(req.tenant_name) ||
        matches(req.notes) ||
        matches(req.status) ||
        matches(String(req.is_approved)) ||
        matches(plane.plane_name) ||
        matches(plane.slug) ||
        (Array.isArray(plane.features) &&
          plane.features.some((f) => matches(f?.name) || matches(f?.key))) ||
        matches(req.created_at);
    }

    // 2) matchesCreated: فلتر النطاق الزمني عند التحديد
    let matchesCreated = true;
    if (hasCreatedFilter) {
      const fStart = createdFrom ? Date.parse(createdFrom) : -Infinity;
      const fEnd = createdTo
        ? Date.parse(createdTo) + 24 * 60 * 60 * 1000 - 1
        : Infinity;
      const tRaw = req.created_at ?? null;
      const tVal = tRaw ? Date.parse(tRaw) : NaN;
      if (isNaN(tVal)) {
        matchesCreated = false;
      } else {
        matchesCreated = tVal >= fStart && tVal <= fEnd;
      }
    }

    // العنصر يمرّ إذا حقّق نص البحث (أو لم يُحدد) وأيضاً شرط التاريخ (أو لم يُحدد)
    return matchesQuery && matchesCreated;
  });

  const pagedRequests = filteredRequests.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const formatDate = (d) => {
    if (!d) return "-";
    try {
      return new Date(d).toLocaleString();
    } catch {
      return String(d);
    }
  };

  const openFeaturesDialog = (features = []) => {
    setDialogFeatures(Array.isArray(features) ? features : []);
    setFeaturesDialogOpen(true);
  };
  const closeFeaturesDialog = () => {
    setFeaturesDialogOpen(false);
    setDialogFeatures([]);
  };

  // إضافة دالة تغيير التاب
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Header Section */}
        <Card
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: 3,
            background: `linear-gradient(135deg, ${themeColors.warning} 0%, #F57C00 100%)`,
            color: "white",
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Avatar
              sx={{
                width: 56,
                height: 56,
                bgcolor: "rgba(255,255,255,0.25)",
                backdropFilter: "blur(10px)",
              }}
            >
              <PendingActionsIcon sx={{ fontSize: 32 }} />
            </Avatar>
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
                طلبات الديمو
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                إدارة ومتابعة طلبات النسخ التجريبية
              </Typography>
            </Box>
          </Box>
        </Card>

        {/* Filters Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: 3,
            border: `1px solid ${themeColors.border.light}`,
          }}
        >
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <FilterListIcon sx={{ color: themeColors.warning }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              البحث والتصفية
            </Typography>
          </Box>

          <Box display="flex" gap={2} flexWrap="wrap">
            <TextField
              size="small"
              variant="outlined"
              label="بحث شامل"
              placeholder="ابحث بالعميل، البريد، الباقة..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ flex: 1, minWidth: 300 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: themeColors.text.secondary }} />
                  </InputAdornment>
                ),
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setSearchQuery("")}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              size="small"
              label="من تاريخ"
              type="date"
              value={createdFrom}
              onChange={(e) => setCreatedFrom(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ minWidth: 150 }}
            />

            <TextField
              size="small"
              label="إلى تاريخ"
              type="date"
              value={createdTo}
              onChange={(e) => setCreatedTo(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ minWidth: 150 }}
            />
          </Box>

          {(searchQuery || createdFrom || createdTo) && (
            <Box mt={2} display="flex" gap={1} alignItems="center">
              <Typography
                variant="caption"
                sx={{ color: themeColors.text.secondary }}
              >
                النتائج: {filteredRequests.length} من {requests.length}
              </Typography>
              <Button
                size="small"
                variant="text"
                onClick={() => {
                  setSearchQuery("");
                  setCreatedFrom("");
                  setCreatedTo("");
                }}
                sx={{ color: themeColors.warning }}
              >
                إعادة تعيين الفلاتر
              </Button>
            </Box>
          )}
        </Paper>

        {/* Tabs */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            border: `1px solid ${themeColors.border.light}`,
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            sx={{
              borderBottom: `1px solid ${themeColors.border.light}`,
              bgcolor: themeColors.background.default,
              "& .MuiTab-root": {
                fontWeight: 600,
                fontSize: "0.95rem",
              },
              "& .Mui-selected": {
                color: themeColors.warning,
              },
              "& .MuiTabs-indicator": {
                backgroundColor: themeColors.warning,
                height: 3,
              },
            }}
          >
            <Tab
              label="الطلبات المعلقة"
              icon={<PendingActionsIcon />}
              iconPosition="start"
            />
            <Tab
              label="الطلبات المرفوضة"
              icon={<CancelIcon />}
              iconPosition="start"
            />
          </Tabs>

          {/* Tab Content */}
          {tabIndex === 0 && (
            <Box sx={{ p: 0 }}>
              {loading && (
                <Box display="flex" justifyContent="center" py={8}>
                  <CircularProgress size={60} sx={{ color: themeColors.warning }} />
                </Box>
              )}

              {error && (
                <Box p={3}>
                  <Alert severity="error" sx={{ borderRadius: 2 }}>
                    {error}
                  </Alert>
                </Box>
              )}

              {!loading && !error && filteredRequests.length === 0 && (
                <Box p={6} textAlign="center">
                  <PendingActionsIcon
                    sx={{
                      fontSize: 80,
                      color: themeColors.text.light,
                      mb: 2,
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{ color: themeColors.text.secondary }}
                  >
                    لا توجد طلبات معلقة حالياً
                  </Typography>
                </Box>
              )}

              {!loading && !error && filteredRequests.length > 0 && (
                <>
                  <TableContainer>
                    <Table sx={{ direction: "rtl" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="right"
                            sx={{
                              bgcolor: themeColors.background.default,
                              fontWeight: 700,
                              borderBottom: `2px solid ${themeColors.warning}`,
                            }}
                          >
                            العميل
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              bgcolor: themeColors.background.default,
                              fontWeight: 700,
                              borderBottom: `2px solid ${themeColors.warning}`,
                            }}
                          >
                            اسم النسخة
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              bgcolor: themeColors.background.default,
                              fontWeight: 700,
                              borderBottom: `2px solid ${themeColors.warning}`,
                            }}
                          >
                            الحالة
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              bgcolor: themeColors.background.default,
                              fontWeight: 700,
                              borderBottom: `2px solid ${themeColors.warning}`,
                            }}
                          >
                            ملاحظات
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              bgcolor: themeColors.background.default,
                              fontWeight: 700,
                              borderBottom: `2px solid ${themeColors.warning}`,
                            }}
                          >
                            الباقة
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              bgcolor: themeColors.background.default,
                              fontWeight: 700,
                              borderBottom: `2px solid ${themeColors.warning}`,
                            }}
                          >
                            الميزات
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              bgcolor: themeColors.background.default,
                              fontWeight: 700,
                              borderBottom: `2px solid ${themeColors.warning}`,
                            }}
                          >
                            تاريخ الإنشاء
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              bgcolor: themeColors.background.default,
                              fontWeight: 700,
                              borderBottom: `2px solid ${themeColors.warning}`,
                            }}
                          >
                            الإجراءات
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {pagedRequests.map((req) => (
                          <TableRow
                            key={req.id}
                            sx={{
                              "&:hover": { bgcolor: themeColors.background.hover },
                              "&:nth-of-type(even)": { bgcolor: "rgba(0,0,0,0.02)" },
                            }}
                          >
                            <TableCell align="right">
                              {req.user ? (
                                <Box>
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 600 }}
                                  >
                                    {req.user.name || "-"}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    sx={{ color: themeColors.text.secondary }}
                                  >
                                    {req.user.email || "-"}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    display="block"
                                    sx={{ color: themeColors.text.secondary }}
                                  >
                                    📞 {req.user.phone || "-"}
                                  </Typography>
                                  <Chip
                                    label={
                                      req.user.system_status === 1
                                        ? "مفعل"
                                        : "معطل"
                                    }
                                    size="small"
                                    sx={{
                                      mt: 0.5,
                                      bgcolor:
                                        req.user.system_status === 1
                                          ? `${themeColors.success}15`
                                          : `${themeColors.error}15`,
                                      color:
                                        req.user.system_status === 1
                                          ? themeColors.success
                                          : themeColors.error,
                                    }}
                                  />
                                </Box>
                              ) : (
                                "-"
                              )}
                            </TableCell>

                            <TableCell align="right">
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 600 }}
                              >
                                {req.tenant_name || "-"}
                              </Typography>
                            </TableCell>

                            <TableCell align="center">
                              <Stack spacing={0.5} alignItems="center">
                                <Chip
                                  label={req.status || "-"}
                                  size="small"
                                  icon={<PendingActionsIcon />}
                                  sx={{
                                    bgcolor: `${themeColors.warning}15`,
                                    color: themeColors.warning,
                                    fontWeight: 600,
                                  }}
                                />
                                <Chip
                                  label={req.is_approved === 0 ? "غير موافق" : "موافق"}
                                  size="small"
                                  variant="outlined"
                                  sx={{
                                    borderColor:
                                      req.is_approved === 0
                                        ? themeColors.error
                                        : themeColors.success,
                                    color:
                                      req.is_approved === 0
                                        ? themeColors.error
                                        : themeColors.success,
                                  }}
                                />
                              </Stack>
                            </TableCell>

                            <TableCell
                              align="right"
                              sx={{
                                fontSize: "0.875rem",
                                color: themeColors.text.secondary,
                              }}
                            >
                              {req.notes || "-"}
                            </TableCell>

                            <TableCell align="right">
                              {req.plane ? (
                                <Box>
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 600 }}
                                  >
                                    {req.plane.plane_name ?? "-"}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    display="block"
                                    sx={{ color: themeColors.text.secondary }}
                                  >
                                    شهري: {req.plane.monthly_price ?? "-"}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    display="block"
                                    sx={{ color: themeColors.text.secondary }}
                                  >
                                    سنوي: {req.plane.yearly_price ?? "-"}
                                  </Typography>
                                </Box>
                              ) : (
                                "-"
                              )}
                            </TableCell>

                            <TableCell align="center">
                              {req.plane &&
                              Array.isArray(req.plane.features) &&
                              req.plane.features.length > 0 ? (
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  gap={1}
                                >
                                  <Chip
                                    label={req.plane.features.length}
                                    size="small"
                                    sx={{
                                      bgcolor: themeColors.warning,
                                      color: "white",
                                      fontWeight: 600,
                                    }}
                                  />
                                  <Tooltip
                                    title="عرض الميزات"
                                    arrow
                                    placement="top"
                                  >
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        openFeaturesDialog(req.plane.features)
                                      }
                                      sx={{ color: themeColors.warning }}
                                    >
                                      <InfoIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              ) : (
                                "-"
                              )}
                            </TableCell>

                            <TableCell align="right">
                              <Typography
                                variant="caption"
                                sx={{ color: themeColors.text.secondary }}
                              >
                                {formatDate(req.created_at)}
                              </Typography>
                            </TableCell>

                            <TableCell align="center">
                              {String(req.status) === "pending" ? (
                                <Stack
                                  direction="row"
                                  spacing={0.5}
                                  justifyContent="center"
                                >
                                  <Tooltip title="رفض الطلب">
                                    <IconButton
                                      size="small"
                                      onClick={() => handleRejectDemo(req.id)}
                                      disabled={
                                        rejectingIds.includes(req.id) ||
                                        acceptLoadingId === req.id
                                      }
                                      sx={{
                                        color: themeColors.error,
                                        "&:hover": { bgcolor: `${themeColors.error}15` },
                                      }}
                                    >
                                      {rejectingIds.includes(req.id) ? (
                                        <CircularProgress size={16} />
                                      ) : (
                                        <CancelIcon fontSize="small" />
                                      )}
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title="قبول الديمو">
                                    <IconButton
                                      size="small"
                                      onClick={() => openAcceptDialog(req)}
                                      disabled={
                                        rejectingIds.includes(req.id) ||
                                        acceptLoadingId === req.id
                                      }
                                      sx={{
                                        color: themeColors.success,
                                        "&:hover": { bgcolor: `${themeColors.success}15` },
                                      }}
                                    >
                                      <CheckCircleIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </Stack>
                              ) : (
                                "-"
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <TablePagination
                    component="div"
                    count={filteredRequests.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    labelRowsPerPage="عدد الصفوف:"
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} من ${count}`
                    }
                    sx={{
                      borderTop: `1px solid ${themeColors.border.light}`,
                      bgcolor: themeColors.background.default,
                    }}
                  />
                </>
              )}
            </Box>
          )}

          {tabIndex === 1 && (
            <Box sx={{ p: 3 }}>
              <AllRejectedDemoTap />
            </Box>
          )}
        </Paper>

        {/* Features Dialog */}
        <Dialog
          open={featuresDialogOpen}
          onClose={closeFeaturesDialog}
          fullWidth
          maxWidth="sm"
          PaperProps={{ sx: { borderRadius: 3 } }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              pb: 2,
              borderBottom: `1px solid ${themeColors.border.light}`,
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <StarsIcon sx={{ color: themeColors.warning }} />
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                تفاصيل الميزات
              </Typography>
              <Chip
                label={dialogFeatures.length}
                size="small"
                sx={{
                  bgcolor: themeColors.warning,
                  color: "white",
                }}
              />
            </Box>
            <IconButton size="small" onClick={closeFeaturesDialog}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            {dialogFeatures.length === 0 ? (
              <Alert severity="info" sx={{ borderRadius: 2 }}>
                لا توجد ميزات
              </Alert>
            ) : (
              <List sx={{ p: 0 }}>
                {dialogFeatures.map((f, idx) => (
                  <React.Fragment key={f.id ?? f.pivot?.feature_id}>
                    <ListItem sx={{ px: 0, py: 2 }}>
                      <ListItemText
                        primary={
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 600 }}
                          >
                            {f.name ?? f.title ?? `feature-${f.id ?? f.pivot?.feature_id}`}
                          </Typography>
                        }
                        secondary={
                          <Box component="span">
                            <Typography variant="caption" display="block">
                              القيمة: {f.pivot?.value ?? "-"}
                            </Typography>
                            <Typography variant="caption" display="block">
                              شهري: {f.pivot?.monthly_cost ?? "-"} • سنوي:{" "}
                              {f.pivot?.yearly_cost ?? "-"}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                    {idx < dialogFeatures.length - 1 && <Divider />}
                  </React.Fragment>
                ))}
              </List>
            )}
          </DialogContent>
        </Dialog>

        {/* Accept Demo Dialog */}
        <Dialog
          open={acceptDialogOpen}
          onClose={closeAcceptDialog}
          fullWidth
          maxWidth="sm"
          PaperProps={{ sx: { borderRadius: 3 } }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              pb: 2,
              background: `linear-gradient(135deg, ${themeColors.success} 0%, #45A049 100%)`,
              color: "white",
            }}
          >
            <Avatar
              sx={{
                width: 48,
                height: 48,
                bgcolor: "rgba(255,255,255,0.25)",
              }}
            >
              <CheckCircleIcon />
            </Avatar>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                قبول النسخة التجريبية
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                تحديد بيانات الديمو للعميل
              </Typography>
            </Box>
            <IconButton
              onClick={closeAcceptDialog}
              sx={{
                position: "absolute",
                left: 8,
                top: 8,
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            {acceptError && (
              <Alert
                severity="error"
                sx={{ mb: 3, borderRadius: 2 }}
                onClose={() => setAcceptError(null)}
              >
                {acceptError}
              </Alert>
            )}
            <Box display="flex" flexDirection="column" gap={2.5}>
              <Box display="flex" gap={2}>
                <TextField
                  label="تاريخ بداية الديمو"
                  type="date"
                  value={startDemo}
                  onChange={(e) => setStartDemo(e.target.value)}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarTodayIcon sx={{ color: themeColors.text.secondary }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": { borderRadius: 2 },
                  }}
                />
                <TextField
                  label="تاريخ نهاية الديمو"
                  type="date"
                  value={endDemo}
                  onChange={(e) => setEndDemo(e.target.value)}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarTodayIcon sx={{ color: themeColors.text.secondary }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": { borderRadius: 2 },
                  }}
                />
              </Box>
              <TextField
                label="التكلفة"
                placeholder="0.00"
                value={demoCost}
                onChange={(e) => setDemoCost(e.target.value)}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachMoneyIcon sx={{ color: themeColors.text.secondary }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": { borderRadius: 2 },
                }}
              />
              <TextField
                label="ملاحظات"
                placeholder="أضف ملاحظات..."
                value={demoNotes}
                onChange={(e) => setDemoNotes(e.target.value)}
                multiline
                rows={3}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ alignSelf: "flex-start", mt: 1 }}
                    >
                      <NotesIcon sx={{ color: themeColors.text.secondary }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": { borderRadius: 2 },
                }}
              />
            </Box>
          </DialogContent>
          <Divider />
          <DialogActions sx={{ p: 2.5, gap: 1 }}>
            <Button
              onClick={closeAcceptDialog}
              disabled={!!acceptLoadingId}
              variant="outlined"
              sx={{ borderRadius: 2, px: 3 }}
            >
              إلغاء
            </Button>
            <Button
              onClick={handleAcceptSubmit}
              variant="contained"
              disabled={!!acceptLoadingId}
              sx={{
                borderRadius: 2,
                px: 4,
                bgcolor: themeColors.success,
              }}
            >
              {acceptLoadingId ? (
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                >
                  <CircularProgress size={20} color="inherit" />
                  <span>جاري القبول...</span>
                </Box>
              ) : (
                <>
                  <CheckCircleIcon sx={{ mr: 1, fontSize: 20 }} />
                  قبول الطلب
                </>
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
};

export default NewRequestsPage;
